// Definition of service tiers and objectives
// https://hello.atlassian.net/wiki/spaces/SRE/pages/166792209/Service+Tiers
export var SERVICE_TIERS = [0, 1, 2, 3];
export var buildServiceTierLabel = function (tier) { return "Tier " + tier; };
export var SERVICE_TIER_LABELS = {};
for (var _i = 0, SERVICE_TIERS_1 = SERVICE_TIERS; _i < SERVICE_TIERS_1.length; _i++) {
    var tier = SERVICE_TIERS_1[_i];
    SERVICE_TIER_LABELS[buildServiceTierLabel(tier)] = tier;
}
var hour = 3600;
export var SERVICE_TIERS_SLO = {
    0: {
        serviceTier: 0,
        availabilityObjective: 99.99,
        reliabilityObjective: 99.99,
        recoveryPointObjective: 1 * hour,
        recoveryTimeObjective: 4 * hour
    },
    1: {
        serviceTier: 1,
        availabilityObjective: 99.95,
        reliabilityObjective: 99.95,
        recoveryPointObjective: 1 * hour,
        recoveryTimeObjective: 6 * hour
    },
    2: {
        serviceTier: 2,
        availabilityObjective: 99.9,
        reliabilityObjective: 99.9,
        recoveryPointObjective: 8 * hour,
        recoveryTimeObjective: 24 * hour
    },
    3: {
        serviceTier: 3,
        availabilityObjective: 99,
        reliabilityObjective: 99,
        recoveryPointObjective: 24 * hour,
        recoveryTimeObjective: 72 * hour
    }
};
